<template>
  <div class="main">
    <p class="title">POSTAGENS ANÔNIMAS</p>
    <b-row align-h="start">
      <b-col sm="12" md="12" lg="12">
        <Tabela />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Tabela from '@/components/dashboard/TabelaContatos.vue';

import backUrl from '@/utils/backUrl.js';
import { seo } from '@/utils/seo.js';

export default {
  name: 'Contatos',
  components: {
    Tabela,
  },
  metaInfo() {
    return seo(
      'Postagens Anônimas',
      'Postagens Anônimas - Site do Projeto Niara',
      `${this.backUrl}/download-file/logo/ProjetoNiaraLogo.png`,
      this.thisUrl,
      'website',
      ' - Dashboard Projeto Niara',
    );
  },
  data() {
    return {
      thisUrl: window.location.href,
      backUrl: backUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
p {
  font-weight: bold;
  font-size: 48px;
}
@media (max-width: 1024px) {
  .main {
    margin-left: 8rem;
  }
}

@media (min-width: 426px) and (max-width: 768px) {
  .main {
    margin-left: 8.5rem;
    margin-right: 0.5rem;
  }
  p {
    margin-left: 8rem;
    font-size: 30px !important;
    margin-bottom: 0px;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .main {
    margin-left: 6.3rem;
  }
  p {
    font-size: 1.6rem;
    font-weight: bold;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .main {
    margin-left: 5.4rem;
  }
  p {
    font-size: 1.4rem;
    font-weight: bold;
  }
}
@media (max-width: 320px) {
  .main {
    margin-left: 5rem;
  }
  p {
    font-size: 1.2rem;
    font-weight: bold;
  }
}
@media (max-width: 280px) {
  .main {
    margin-left: 5rem;
  }
  p {
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
  }
}
</style>

<style lang="scss" scoped>
.main {
  margin-top: 3rem;
}
</style>
